import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Users } from 'src/app/core/models/users';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-delete-user',
  templateUrl: './delete-user.component.html',
  styleUrls: ['./delete-user.component.scss']
})
export class DeleteUserComponent implements OnInit {

  constructor(
    public dialog: MatDialogRef<DeleteUserComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { depName: string; userName: string; message: string; showNote: boolean; Users: Users },
    private userService: UserService,
    private snackBar: MatSnackBar) { }

  message: string = "";
  note: string = "";
  showNote: boolean = false;

  ngOnInit() {
    this.message = this.data.message;
    this.showNote = this.data.showNote;
    if (this.showNote) {
      this.note = "Note : Global admins and users which are attached to any deployments will not be deleted."
    }
  }

  onClose() {
    this.dialog.close(false);
  }

  onCancel() {
    this.dialog.close(false);
  }

  onSubmit() {
    if (this.showNote) {
      this.dialog.close(true);
    }
    let user: Users = {
      userName: this.data.userName
    };
    this.dialog.close(user);
  }
}
